import Jaula from './Jaula';

export default Jaula;
